import {
    mapState
} from 'vuex'
import store from "@/store/"
// 尝试将用户在根目录中的store/index.js的vuex的state变量，全部加载到全局变量中
let $uStoreKey = [];
try {
    $uStoreKey = store.state ? Object.keys(store.state) : [];
} catch (e) { }
let mixins = {
    data() {
        return {
            datas: {
                data: [],
                total: 0,
                page: 0,
                limit: 20,
                status: 0,
                with: [],
                append: [],
                order: {
                    id: 'desc'
                },
                add: {
                    kw: ''
                },
            },
            read_with: [],
            r: {},
            show_save: false,
            ids: [],
            cfg: {},
            mix_fields: [],
            do_timer_datas: null,
            mx_loading: false,
            cates: []
        };
    },
    computed: {
        ...mapState($uStoreKey),
    },
    watch: {
        'datas.add': {
            deep: true,
            handler() {
                clearTimeout(this.do_timer_datas);
                this.do_timer_datas = setTimeout(() => {
                    this._load(1);
                }, 200);
            }
        }
    },
    created() {
        this.$vuex = (name, value) => {
            this.$store.commit('$uStore', {
                name,
                value
            })
        };
        if (this.$parent && this.$parent.is_admin_page && this.table) {
            this.$vuex('vuex_table', this.table);
        }
    },
    methods: {
        _is_show_group(code) {
            if (this.vuex_admin.admin_group_id == 1) {
                return true;
            }
            if (typeof code == 'object') {
                if (code.indexOf(this.vuex_admin.admin_group_id) >= 0) {
                    return true;
                }
            } else {
                if (this.vuex_admin.admin_group_id == code) {
                    return true;
                }
            }
            return false;
        },
        _vuex(name, val) {
            this.$vuex(`vuex_${name}`, val);
        },
        _admins(ids) {

            this.$http.post('admin/admins', {
                ids
            }).then(res => {
                if (res.code) {
                    this.admins = res.data;
                }
            })
        },
        _cates() {
            this.$http.post(`${this.table}_cate/list`, {
                limit: 100
            }).then(res => {
                if (res.code) {
                    this.cates = res.data.data;
                }
            })
        },
        _reset(field) {
            this[field] = this.$options.data()[field];
        },
        _time_date(time) {
            time = Math.abs(time * 1000);
            let SECOND = 1000
            let MINUTE = 60 * SECOND
            let HOUR = 60 * MINUTE
            let DAY = 24 * HOUR
            let days = Math.floor(time / DAY) || 0
            let hours = Math.floor((time % DAY) / HOUR) || 0
            let minutes = Math.floor((time % HOUR) / MINUTE) || 0
            // let seconds = Math.floor((time % MINUTE) / SECOND) || 0
            let str = hours + ' ' + "小时" + ' ' + minutes + ' ' + "分钟"
            if (days) {
                str = days + ' ' + "天" + ' ' + str;
            }
            return str;
        },
        _table_time(row, column, cellValue, index) {
            // console.log(row, column, cellValue, index);
            return this._time_format(cellValue);
        },
        _time_format(dateTime = null, fmt = 'yyyy-mm-dd hh:MM') {
            // 如果为null,则格式化当前时间
            if (!dateTime) {
                return '--';
            }
            // 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
            if (dateTime.toString().length == 10) dateTime *= 1000
            const date = new Date(dateTime)
            let ret
            const opt = {
                'y+': date.getFullYear().toString(), // 年
                'm+': (date.getMonth() + 1).toString(), // 月
                'd+': date.getDate().toString(), // 日
                'h+': date.getHours().toString(), // 时
                'M+': date.getMinutes().toString(), // 分
                's+': date.getSeconds().toString() // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            }
            for (const k in opt) {
                ret = new RegExp(`(${k})`).exec(fmt)
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
                }
            }
            return fmt
        },
        _msg(msg, option = {
            code: 1
        }) {
            if (option.code) {
                this.$message.success(msg);
            } else {
                this.$message.error(msg);
            }
        },
        _do_more(res) {
            let arr = res.split('|');
            if (arr.length == 2) {
                this._quick_edit(this.table, this.ids, arr[0], arr[1]);
                this._load();
            }
        },
        _total(scene = '', option = {}) {
            this.$http.post(`index/total?scene=${scene}`, option).then(res => {
                this.total = res.data;
            });
        },
        _to_url(url) {
            this.$router.push(url);
        },
        _favicon(faviconurl) {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'icon';
            link.href = faviconurl;
            document.getElementsByTagName('head')[0].appendChild(link);
        },
        _admin(data = {}) {
            return new Promise(s => {
                this.$http.post('admin/my', data).then(res => {
                    this.admin = res.data;
                    s(res);
                    sessionStorage.setItem('session_admin', res.data);
                })
            })
        },
        _map() {
            let map = this.map = new BMap.Map('map_box');
            map.centerAndZoom(this.cfg.app_city, 15);
            map.enableScrollWheelZoom(true);
            return map;
        },
        _out_excel() {
            this.$http.post('index/out_excel', {
                table: this.table,
                ...this.datas.order
            }, {
                responseType: 'blob',
            }).then(res => {
                let url = window.URL.createObjectURL(new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
                }))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url;
                let excelName = `下载.xlsx`;
                link.setAttribute('download', excelName)
                document.body.appendChild(link)
                link.click()
                link.remove()
            })
        },
        _areas() {
            this.$http.post('area/list', {
                order: 'myorder desc,id asc'
            }).then(res => {
                this.areas = res.data.data;
            })
        },
        _quick_edit(table, id, field, value, type = 0) {
            return new Promise(s => {
                this.$http.post('index/quick_edit', {
                    table: table,
                    id: id,
                    field: field,
                    value: value
                }).then(res => {
                    if (res.code) {
                        this._load(type);
                        s(res);
                    }
                })
            })
        },
        _quick_edit_ok(table, id, field, value) {
            this.$confirm('确定操作吗?', '').then(res => {
                return new Promise(s => {
                    this.$http.post('index/quick_edit', {
                        table: table,
                        id: id,
                        field: field,
                        value: value
                    }).then(res => {
                        if (res.code) {
                            this._load(1);
                            s(res);
                        }
                    })
                })
            });
        },
        _files(files, field = '') {
            if (files == undefined) {
                return [];
            }
            let res = [];
            for (let i = 0; i < files.length; i++) {
                if (files[i].field == field) {
                    res.push(files[i]);
                }
            }
            return res;
        },
        _scroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            var scrollTop1 = document.getElementById('page').scrollTop
            scrollTop1 >= 152 ? this.fixed = true : this.fixed = false
        },
        _load(type = 0) {
            if (type == 1) {
                this.datas.page = 0;
                this.datas.status = 0;
            }
            if (this.datas.status != 0) {
                return;
            }
            this.datas.status = -1;
            let http = this.datas.url || `${this.table}/list`;
            if (!http) {
                return;
            }
            let page = this.datas.page;
            this.$http.post(http, Object.assign({}, {
                page: page,
                order: this._attr(this.datas, 'order'),
                limit: this._attr(this.datas, 'limit'),
                with: this.datas.with || [],
                with_count: this.datas.with_count || [],
                append: this.datas.append || [],
            }, this.datas.add)).then(res => {
                this.datas.status = 0;
                let add = this._attr(res.data, 'data', []);
                this.datas.data = add;
                this.datas.total = res.data.total || 0;
                this.datas.page = res.data.current_page;
                if (add.length <= 0) {
                    this.datas.status = 1;
                }
            });
        },
        _attr(obj, search, re = "") {
            const arr = search.split(".");
            if (!obj) {
                return re;
            }
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].indexOf("[") >= 0 && arr[i].indexOf("]") >= 0) {
                    let index = arr[i].split("[")[1].split("]")[0]
                    obj = obj[index];
                } else {
                    obj = obj[arr[i]];
                }
                if (obj === undefined) {
                    return re;
                }
            }
            return obj;
        },
        _config(fields = [], callback) {
            this.$http.post('config/index', {
                fields: fields
            }).then(res => {
                this.cfg = res.data;
                if (callback) {
                    callback(res);
                }
            });
        },
        _save(id = 0, data = {}, append = [], callback) {
            if (this.show_save !== undefined) {
                this.show_save = true;
            }
            if (this.r_is_reset !== false) {
                this.r = this.$options.data().r;
            }
            if (id > 0) {
                this.$http.post(`${this.table}/show`, {
                    id: id,
                    append: [
                        ...this.r_append || [],
                        ...append || [],
                        ...data.append || []
                    ],
                    with_count: this.r_with_count
                }).then(res => {
                    if (res.code) {
                        this.r = res.data;
                    }
                    // this.r = {
                    //     ...this.r,
                    //     ...res.data,
                    //     ...data
                    // };
                    if (callback) {
                        callback(res.data);
                    }
                });
            } else {
                this.r = {
                    ...this.r,
                    ...data
                };
            }
        },
        _read_config() {
            this.$http.post('config/read').then(res => {
                this.r = res.data;
            })
        },
        _read(id, data = {}, table = '') {
            this.$http.post(`${this.table}/show`, {
                id: id,
                append: this.r_append
            }).then(res => {
                this.r = {
                    ...this.$options.data().r,
                    ...res.data,
                    ...data
                };
            });
        },
        _submit(opt = {}) {
            if (opt.is_val) {
                var val = true;
                this.$refs.r.validate(validate => {
                    if (validate) {
                        val = true;
                    } else {
                        val = false;
                    }
                })
            } else {
                val = true;
            }
            if (val) {
                let action = 'add';
                if (this.r.id) {
                    action = 'edit';
                }
                this.$http.post(`${this.table}/${action}`, {
                    ...this.r,
                    ...this.r_add
                })
                    .then(res => {
                        if (res.code) {
                            this.show_save = false;
                            this.r = this.$options.data().r;
                            this._load(1);
                            // location.reload();
                        }
                    });
            }
        },
        _del(id = 0) {
            // this.$http.post(`${this.table}/del`, {
            //     id: id
            // }).then(res => {
            //     this._load();
            // });
            // return;
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post(`${this.table}/del`, {
                    id
                }).then(res => {
                    this._load();
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        _select(val) {
            this.ids = [];
            for (let i = 0; i < val.length; i++) {
                this.ids.push(val[i].id);
            }
        },
        _size(val) {
            this.datas.limit = val;
            this._load(1);
        },
        _page(val) {
            this.datas.page = val;
            this._load();
        },
        _sort(obj) {
            let type = "desc";
            if (obj.order == "ascending") {
                type = "asc";
            }
            //  排序字段主要  group.title   user_group_id
            if (obj.column.sortBy !== undefined) {
                this.datas.order = obj.column.sortBy + " " + type;
            } else {
                this.datas.order = obj.prop + " " + type;
            }
            this.datas.page = 1;
            this._load(1);
        },
        // 影藏字符串
        _hide_str(str, frontLen, endLen) {
            var newStr;
            var len = str.length - frontLen - endLen;
            if (str.length === 2) {
                newStr = str.substring(0, 1) + '*';
            } else if (str.length > 2) {
                var char = '';
                for (let i = 0; i < len; i++) {
                    char += '*';
                }
                newStr = str.substring(0, frontLen) + char + str.substring(str.length - endLen);
            } else {
                newStr = str;
            }
            return newStr;
        }
    }
}
export default mixins
